export default __webpack_public_path__ + "static/media/igpost3.3f8688f6.png";